import React from "react";
import "./ShowSingleInvites.scss";

//constants
import {Strings} from "../../../../Resources/Strings/i18n"

//material ui
import Chip from "@material-ui/core/Chip";
import DoneIcon from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";

function showSingleInvites(props) {

  let { first_name, last_name, mobile, type,email } = props.inviteData || {};
  first_name = first_name || "";
  last_name = last_name || "";
  mobile = mobile || "";
  type = type || "";
  email= email || ""

  let fullName = first_name
    ? first_name.toUpperCase()
    : "" + last_name
    ? last_name.toUpperCase()
    : "";
  return (
    <div className="showSingleInvites">
      <div className="leftData">
        <div className="profileImgCard">
          <div className="initialsCard">
            <label>
              {first_name.toUpperCase().charAt(0)}
              {last_name.toUpperCase().charAt(0)}
            </label>
          </div>
        </div>
      </div>
      <div className="rightData">
        <div className="profileNameCard">
          {fullName}
          <div className="typeData">{type}</div>
        </div>
        <div className="profileMobileNumber">{mobile?mobile:email}</div>
        <div className="profileChoice">
          <Chip
            label={Strings("Accept")}
            onClick={() => {
              props.acceptDeclineHandler({ status:"ACCEPTED",...props.inviteData })
            }}
            onDelete={() => {}}
            deleteIcon={<DoneIcon />}
            variant="outlined"
            className="Accept"
          />
          <Chip
            label={Strings("Decline")}
            onClick={(handleClick) => {
              props.acceptDeclineHandler({status:"DECLINED",...props.inviteData})
            }}
            onDelete={(handleDelete) => {}}
            deleteIcon={<CloseIcon />}
            variant="outlined"
            className="Decline"
          />
        </div>
      </div>
    </div>
  );
}

export default showSingleInvites;
